import { render, staticRenderFns } from "./TenantRegistration.vue?vue&type=template&id=7eb7d832&scoped=true&"
import script from "./TenantRegistration.vue?vue&type=script&lang=js&"
export * from "./TenantRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb7d832",
  null
  
)

export default component.exports